import React from 'react';
import classNames from 'classnames';

import RichTextEditor from 'ui/rich-text-editor/RichTextEditor';
import { useId } from 'ui/utils';

type Props = {
  id?: string;
  name?: string;
  error?: string;
  placeholder?: string;
  value?: string;
  autofocus?: boolean;
  onChange: (newValue: string) => void;
  className?: string;
};

function RichText({ id, name, error, placeholder, value, autofocus, onChange, className = 'border' }: Props) {
  const internalId = useId();

  if (!name) {
    name = `richtext-${internalId}`;
  }

  if (!id) {
    id = `${name}__id`;
  }

  return (
    <div className={classNames('relative', className)}>
      <RichTextEditor initialValue={value} autofocus={autofocus} onChange={onChange} placeholder={placeholder} />
      {error && (
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <svg
            className="h-5 w-5 text-red-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      )}
    </div>
  );
}

export default RichText;
